"use client";
import { useEffect } from 'react';
const OneSignalComponent = () => {
  useEffect(() => {
    // Load the OneSignal SDK script
    const script = document.createElement('script');
   // script.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.sw.js"; // IMPORTANT: Use `.page.js` (not `.sw.js`)
    //script.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js"; // IMPORTANT: Use `.page.js` (not `.sw.js`)
    script.src="/OneSignalSDK.page.js"
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      console.log("✅ OneSignal SDK Loaded");
      // Initialize OneSignal
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push(async function (OneSignal: any) {
        // await OneSignal.init({
        //   appId: "c567c2fb-3960-4241-9b71-15f7a2c85b51", // Replace with your App ID
        //   notifyButton: {
        //     enable: true,
        //   },
        //   allowLocalhostAsSecureOrigin: true,
        //   serviceWorkerPath: "/OneSignalSDKWorker.js",
        
        // });
        await OneSignal.init({

          appId: "c567c2fb-3960-4241-9b71-15f7a2c85b51",
  
          notifyButton: {
  
              enable: true
  
          },
  
          serviceWorkerParam: { scope: "/push/signal/" },
  
          serviceWorkerPath: "/push/signal/OneSignalSDKWorker.js",
  
        });
        console.log("✅ OneSignal Initialized");
        // Optional: Force prompt
        OneSignal.showSlidedownPrompt();
        // Log subscription status
        OneSignal.isPushNotificationsEnabled(function (isEnabled: boolean) {
          console.log("🔔 Push notifications enabled:", isEnabled);
        });
        // Get and log Player ID (User ID)
        OneSignal.getUserId().then((id: string) => {
          console.log("OneSignal Player ID:", id);
        });
      });
    };
    return () => {
      // Cleanup: Remove SDK script
      document.body.removeChild(script);
    };
  }, []);
  return null;
};
export default OneSignalComponent;


